import _omit from 'lodash/fp/omit';
import _pick from 'lodash/fp/pick';
import { createAction } from 'redux-actions';
import { createRoutine } from '../common/utils/routines';

const metaKeys = ['target', 'provider', 'attempt'];
const payloadMetaBuilders = [_omit(metaKeys), _pick(metaKeys)];

export const fetchUser = createRoutine('integrations/FETCH_USER', ...payloadMetaBuilders);
export const fetchPublishTargets = createRoutine('integrations/FETCH_PUBLISH_TARGETS', ...payloadMetaBuilders);
export const createPublishTarget = createRoutine('integrations/CREATE_PUBLISH_TARGET', ...payloadMetaBuilders);
export const unlink = createAction('integrations/UNLINK');
